/* eslint-disable arrow-body-style */
/* eslint-disable no-param-reassign */
import axios from 'axios';
import config from '@/util/config';

const instance = axios.create({
    baseURL: config.url,
    timeout: 5000,
    headers: {
        'Content-type': 'applicetion/json; charset=utf-8'
    }
});

/**
 * 请求拦截
 */
instance.interceptors.request.use((req) => {
    return req;
}, (error) => {
    return Promise.reject(error);
});

/**
 * 响应拦截
 */
instance.interceptors.response.use((response) => {
    return response;
}, (error) => {
    return Promise.reject(error);
});

export default instance;



// WEBPACK FOOTER //
// ./src/util/http/axios.js